import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import rootReducer from '../reducers/rootReducer';

export default function configureStore(defaultState = { currentUser: {} }, defaultReducer = rootReducer) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(defaultReducer, defaultState, composeEnhancers(applyMiddleware(thunk)));
}
